import { ActionLabels, buttonLabels, emptyLabels, GridStatusLabelVariant, pageTitles, RechargeStatusLabels } from '../shared/constants';
import { RechargeStatus } from '../../models/transaction-history.model';
import { setBackHandler, setHeaderTitle, setRefreshHandler, } from '../../helpers/header.helper';
import GridComponent from '../shared/grid';
import { ColDef, ColumnApi, ValueGetterParams } from 'ag-grid-community';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import PageHeaderComponent from '../shared/page-header.component';
import { useState, useEffect } from 'react';
import { dateComparator } from '../shared/grid/grid.services';
import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { CancelIcon, ViewDetailsIcon } from '../../icon';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { OrganizationService } from '../../services/OrganizationService';
import { MapToOrgPlanHistory, OrgPlanHistory } from '../../models/organization.model';
import NewPlanCard from '../new-subscription-flow/NewPlanCard';
import ButtonComponent from '../shared/button/button.component';
import { UserService } from '../../services/UserService';
import { PlanType } from '../../models/plans.model';
import { AppRoutes } from '../routes/route.path';


const OrgPlanHistoryComponent = () => {
    const navigate = useNavigate();
    const params = useParams();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [gridApi, setGridApi] = useState<any>()
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [planHistory, setPlanHistory] = useState<OrgPlanHistory[]>([])
    const [openPlanDetails, setOpenPlanDeatils] = useState<boolean>(false)
    const [selectedPlanHistory, setSelectedPlanHistroy] = useState<OrgPlanHistory>();

    let PlanHistoryColoumnDefs: ColDef[] = [
        {
            field: "SubscriptionId",
            headerName: "ID",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.SubscriptionId}`
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "15px" } : null,
            minWidth: 100
        },
        // {
        //     autoHeight: true,
        //     headerComponentParams: {
        //         template: `${HeaderTemplate.plansAddOn}`
        //     },
        //     valueGetter: (params: ValueGetterParams) => {
        //         return params.data.PlanName
        //     },
        //     cellRendererSelector: (params: ICellRendererParams) => {
        //         if (!!params.data) {
        //             const label = params.data.PlanName
        //             const Icon = params.data.PlanType === 2 ? AddOnViewIcon : PlansGridIcon
        //             const css = params.data.PlanType === 2 ? "color-addon-text" : "color-plan-text"
        //             const Status = {
        //                 component: TypeRenderer,
        //                 params: {
        //                     Icon: Icon, Label: label, Id: params.data.ID, ClassName: css
        //                 }
        //             }
        //             return Status
        //         }
        //     },
        // },
        {
            field: "PlanName",
            headerName: "Plan",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.PlanName}`
                }
            },
        },
        {
            field: "Quantity",
            headerName: "Quantity",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.Quantity}`
                }
            },
        },
        {
            field: "StatusType",
            headerName: "Status",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.StatusType === RechargeStatus.ONGOING ? RechargeStatusLabels.ONGOING : params.data.StatusType === RechargeStatus.UPCOMING ? RechargeStatusLabels.UPCOMING : params.data.StatusType === RechargeStatus.COMPLETED ? RechargeStatusLabels.COMPLETED : params.data.StatusType === RechargeStatus.ON_HOLD ? RechargeStatusLabels.ON_HOLD : params.data.StatusType === RechargeStatus.CANCELLED ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const label = params.data.StatusType === RechargeStatus.ONGOING ? RechargeStatusLabels.ONGOING : params.data.StatusType === RechargeStatus.UPCOMING ? RechargeStatusLabels.UPCOMING : params.data.StatusType === RechargeStatus.COMPLETED ? RechargeStatusLabels.COMPLETED : params.data.StatusType === RechargeStatus.ON_HOLD ? RechargeStatusLabels.ON_HOLD : params.data.StatusType === RechargeStatus.CANCELLED ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE
                    const variant = params.data.StatusType === RechargeStatus.ONGOING ? GridStatusLabelVariant.Info : params.data.StatusType === RechargeStatus.UPCOMING ? GridStatusLabelVariant.Other : params.data.StatusType === RechargeStatus.COMPLETED ? GridStatusLabelVariant.Active : params.data.StatusType === RechargeStatus.ON_HOLD ? GridStatusLabelVariant.Warning : GridStatusLabelVariant.Danger;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID,
                        }
                    }
                    return Status
                }
            },
        },
        {
            field: "CreatedDate",
            headerName: "Created Date",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.CreatedDateTime}`
            },
            sort: "desc",
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
        },
        {
            field: "StartDate",
            headerName: "Start Date",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.StartDate}`
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.StartDate, nodeB.data.StartDate),
        },
        {
            field: "EndDate",
            headerName: "End Date",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${!!params.data.EndDate ? params.data.EndDate : "---"}`
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.EndDate, nodeB.data.EndDate),

        },
        {
            field: "RenewalDate",
            headerName: "Renewal Date",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${!!params.data.RenewDate ? params.data.RenewDate : "---"}`
            },
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer MenuData={[{
                    Name: ActionLabels.SEAT_DETAILS,
                    Icon: ViewDetailsIcon,
                    OnClick: () => { openPlanHistoryDeatils(params.data) }
                }
                ]}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const openPlanHistoryDeatils = (data) => {
        setOpenPlanDeatils(true);
        setSelectedPlanHistroy(data)
    }

    const closePlanHistoryDetails = () => {
        setOpenPlanDeatils(false)
        setSelectedPlanHistroy(undefined);
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const onSearch = (e: any) => {
        gridApi.setQuickFilter(e.target.value)
    }

    const getOrgPlanHistory = () => {
        const orgId = !UserService.hasSysAdminRole() ? UserService.getCurrentUserFromLocalStorage().OrgId : params.orgId
        OrganizationService.GetNewOrganizationRechargeHistory(orgId).then((res) => {
            setPlanHistory(res.data.map(MapToOrgPlanHistory))
        }).catch((err) => { })
    }

    useEffect(() => {
        getOrgPlanHistory();
        setHeaderTitle(pageTitles.SEAT_HISTORY);
        setBackHandler(() => UserService.hasSysAdminRole() ? navigate(-1) : navigate(AppRoutes.DASHBOARD));
        setRefreshHandler(getOrgPlanHistory)
    }, []);

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            <PageHeaderComponent
                Actions={[]}
                ShowFilterIcon={false}
                onSearch={onSearch}
                PlaceHolder={"Find a Plan..."}
                Count={0} />
            <GridComponent
                ColumnDefs={PlanHistoryColoumnDefs}
                RowData={planHistory}
                OnGridReady={onGridReady}
                IsPaginationEnabled={true}
                EmptyLabel={emptyLabels.TRANSACTION_HISTORY}
                LockVisible={true}
                gridApi={gridApi}
                isHorizontalScroll={true}
            />
            {openPlanDetails &&
                <Dialog fullWidth onClose={closePlanHistoryDetails} open={openPlanDetails} BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "br-2 dialogue-shadow w-p-50 " }}>
                    <DialogTitle className="dialog-header">
                        <div className="h1 color-display-title d-flex">
                            {ActionLabels.SEAT_DETAILS}
                            <Tooltip title='Close' placement='bottom'><span className={"ml-auto"}><CancelIcon className={"c-pointer"} onClick={closePlanHistoryDetails} /></span></Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className={" o-hidden pt-0 p-relative"} >
                        <div >
                            <NewPlanCard
                                key={selectedPlanHistory.Id}
                                Index={1}
                                Plan={selectedPlanHistory.Plan}
                                ShowAddOnOptions={false}
                                SelectionCount={(0)}
                                OnSelectionChange={(count) => { }}
                                PlanSelected={true}
                                HideBuyNow={false}
                                DisplayYearlyPrice={selectedPlanHistory.IsYearPlan}
                                EnableCounter={false}
                            />
                        </div>
                        {selectedPlanHistory?.PlanType === PlanType.TIER && <div className='p-absolute b-1 w-p-100 l-0  tooltip-z-index  d-flex justify-center align-center'>
                            <div className='px-2 py-1 bg-color-secondary br-2 color-primary-accent h4-regular'>
                                {selectedPlanHistory.Quantity}
                            </div>
                        </div>
                        }
                    </DialogContent>
                    <DialogActions className='pb-2'>
                        <ButtonComponent OnClick={() => closePlanHistoryDetails()} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1"} Variant={"secondary-btn-small"} />
                    </DialogActions>
                </Dialog>
            }
        </div>
    )
}

export default OrgPlanHistoryComponent;